(() => {
  class GamedayFlagArGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.dialog = this.querySelector('[data-flag-ar-dialog]');
      this.message = this.querySelector('[data-flag-ar-message]');
      this.querySelector('[data-flag-ar-continue]')?.addEventListener('click', () => this.launch());
      this.querySelector('[data-flag-ar-cancel]')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('close', () => this.trigger?.focus({ preventScroll: true }));
    }

    get open() { return Boolean(this.dialog?.open); }

    openFor(trigger, getViewer) {
      if (!this.dialog || this.launching) return;
      this.trigger = trigger;
      this.getViewer = getViewer;
      if (this.message) this.message.textContent = '';
      if (!this.open) this.dialog.showModal();
    }

    async launch() {
      if (this.launching || !this.open) return;
      // Resolve at Continue time so a newly prepared custom proof is used.
      const viewer = this.getViewer?.();
      if (typeof viewer?.activateAR !== 'function' || viewer.loaded === false) {
        if (this.message) this.message.textContent = 'The 3D viewer is still loading. Tap OPEN AR again in a moment.';
        return;
      }
      if (!viewer.canActivateAR) {
        if (this.message) this.message.textContent = 'AR is not available in this browser. Open this product page on an AR-capable phone to place your flag.';
        return;
      }
      this.launching = true;
      try {
        // Preserve the mobile user gesture by launching directly from this click.
        const pending = viewer.activateAR();
        this.dialog.close();
        await pending;
      } catch (_error) {
        if (!this.open) this.dialog.showModal();
        if (this.message) this.message.textContent = 'AR did not open. Tap OPEN AR to try again, or go back to your flag.';
      } finally {
        this.launching = false;
      }
    }
  }

  if (!customElements.get('gameday-flag-ar-guide')) {
    customElements.define('gameday-flag-ar-guide', GamedayFlagArGuide);
  }
})();
